import React from 'react';
import { ControlLabel } from 'react-bootstrap';
import {  actions } from 'react-redux-form';
import { connect } from 'react-redux';
import ColorPickerField from './color-picker-field';
import './color-picker.css';

class ColorPicker extends React.Component {
  state = {
    selectedColor: '',
    backgroundColor: '',
    textColor: ''
  };

  handleColorChange = (newColor) => {
    const { dispatch, model, textModel } = this.props;
    const { backgroundColor, textColor } = this.state;
    this.setState({ selectedColor: newColor });
    if (newColor === 'Other') {
      dispatch(actions.change(model, backgroundColor));
      dispatch(actions.change(textModel, textColor));
    } else {
      dispatch(actions.change(model, newColor));
      if (model !== textModel) {
        dispatch(actions.change(textModel, ''));
      }
    }
  }

  handleBackgroundColorChange = (value) => {
    const newColor = value.target.value;
    const { dispatch, model } = this.props;
    this.setState({ backgroundColor: newColor });
    dispatch(actions.change(model, newColor));
  };

  handleTextColorChange = (value) => {
    const newColor = value.target.value;
    const { dispatch, textModel } = this.props;
    this.setState({ textColor: newColor });
    dispatch(actions.change(textModel, newColor));
  };

  componentDidUpdate(prevProps) {
    const { colors, defaultColor, defaultTextColor } = this.props;
    if (defaultColor !== prevProps.defaultColor) {
      this.setState({ backgroundColor: colors.includes(defaultColor) ? '' : defaultColor });
    }

    if (defaultTextColor !== prevProps.defaultTextColor) {
      this.setState({ textColor: colors
        .includes(this.props.defaultTextColor) ? '' : this.props.defaultTextColor });
    }
  }

  render() {
    const { label, backgroundColorPicker, defaultColor, defaultTextColor, model, colors } = this.props;
    const { selectedColor, backgroundColor, textColor } = this.state;
    const checkedColor = selectedColor || defaultColor || defaultTextColor;

    return (
      <div>
        <div>
          <ControlLabel>
            {label}
          </ControlLabel>
        </div>
        <div className="color-picker-flex-container" data-cy={`color-picker-${model}`}>
          { colors.map(color => {
            return (
              <div key={model + color} className="color-picker-option">
                <div className="color-picker-radio-button">
                  <input
                    className="color-picker-radio"
                    type="radio"
                    key={model + color}
                    name={model + color}
                    value={color}
                    onChange={() => this.handleColorChange(color)}
                    checked={checkedColor === color}
                  />
                </div>
                <div className="color-picker-label">
                  {color}
                </div>
              </div>
            )
          })}

          <div className="color-picker-option">
            <div className="color-picker-radio-button">
              <input
                className="color-picker-radio"
                type="radio"
                key={'Other'}
                value={'Other'}
                onChange={() => this.handleColorChange('Other')}
                checked={!colors.includes(checkedColor)}
              />
            </div>
            <div className="color-picker-label">
              Other
            </div>
          </div>

          { !colors.includes(checkedColor) && backgroundColorPicker &&
            <ColorPickerField
              label="Background colour"
              handleChange={this.handleBackgroundColorChange}
              value={backgroundColor}
            />
          }
          { !colors.includes(checkedColor) &&
            <ColorPickerField
              label="Text colour"
              handleChange={this.handleTextColorChange}
              value={textColor}
            />
          }
        </div>
      </div>
    );
  }
}

export default connect()(ColorPicker);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/color-picker.jsx